import Entity from '../entity'
export default class CampanaTipo extends Entity<number>{
    nombre: string;
    descripcion: number
}